import { Mixins, Component } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/achievement';
import pageMixin from '../../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private sList: any = [];

  private column: Array<ITABLECOLCONF> = [{
    label: '标题',
    prop: 'medalTitle',
    align: 'center',
  }, {
    label: '描述',
    align: 'center',
    prop: 'medalDescription',
  }, {
    label: '缩略图',
    align: 'center',
    prop: 'medalImagePath',
    custom: true,
    icon: true,
  }, {
    label: '对应方法',
    align: 'center',
    prop: 'medalFunction',
  }, {
    label: '总分',
    prop: 'medalScore',
    align: 'center',
  }, {
    label: '状态',
    prop: 'activeTag',
    align: 'center',
    custom: true,
    tags: [{
      value: '0',
      type: 'error',
      label: '停用',
    }, {
      value: '1',
      type: 'success',
      label: '激活',
    }],
  }, {
    label: '创建时间',
    prop: 'createTime',
    align: 'center',
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    maxBtn: 2,
    btnList: [
      {
        title: '编辑',
        name: '/set:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleUpdateForm,
        log: {
          name: '系统配置 - 编辑',
          component: 'set/tableMixin',
        },
      },
      {
        title: '删除',
        name: '/set:update',
        icon: 'remove',
        type: 'info',
        callback: this.handleRmove,
        log: {
          name: '系统配置 - 删除',
          component: 'set/tableMixin',
        },
      },
    ],
    align: 'center',
  }];

  private loading: boolean = true;

  mounted() {
    this.getData();
  }

  /* eslint-disable class-methods-use-this */
  /**
   * @author ruixue
   * @desc 获取配置列表
   */
  getData() {
    this.loading = true;
    api.getAchievement(this.page).then((res: any) => {
      this.sList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /* eslint-disable class-methods-use-this */
  handleUpdateForm(row: any) {}

  /**
   * @author ruixue
   * @desc 删除配置操作
   * @param { any } row 行数据
  */
  handleRmove(row: any) {
    this.confirm('此操作将永久删除该数据, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeAchievement(row.pid).then(() => {
        this.getData();
        close();
        this.$log({
          title: '系统配置 - 删除 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '系统配置 - 删除 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }
}
